/**
 * @generated SignedSource<<e9f7b80e7a587319b3c68c2dc434d1ad>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateZendeskTicketInput = {
  attachmentUrls?: ReadonlyArray<string> | null;
  category: string;
  countryRegion?: string | null;
  email: string;
  employees?: string | null;
  fileUpload?: string | null;
  industry?: string | null;
  lastName?: string | null;
  message: string;
  name: string;
  orderIDsAndErrorCodes?: string | null;
  phone?: string | null;
  role?: string | null;
  salesChannels?: string | null;
  sellerID?: number | null;
  subcategory?: string | null;
  subscriptionPlan?: string | null;
  subscriptionStatus?: string | null;
  websiteURL?: string | null;
};
export type supportTicketDropdownMutation$variables = {
  input: CreateZendeskTicketInput;
};
export type supportTicketDropdownMutation$data = {
  readonly createZendeskTicket: {
    readonly errorMessage: string | null;
    readonly success: boolean;
    readonly ticketId: number;
  };
};
export type supportTicketDropdownMutation = {
  response: supportTicketDropdownMutation$data;
  variables: supportTicketDropdownMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateZendeskTicketPayload",
    "kind": "LinkedField",
    "name": "createZendeskTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "supportTicketDropdownMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "supportTicketDropdownMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a9d51045146820f79ab05664011df55d",
    "id": null,
    "metadata": {},
    "name": "supportTicketDropdownMutation",
    "operationKind": "mutation",
    "text": "mutation supportTicketDropdownMutation(\n  $input: CreateZendeskTicketInput!\n) {\n  createZendeskTicket(input: $input) {\n    ticketId\n    success\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "666c536674b6e1ae76948fd3e03ea6ec";

export default node;
